import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollDeleteUserPerquisiteAssignmentsResponse,
  PayrollDeleteUserPerquisiteAssignmentsVariables,
} from './types';

export const deleteUserPerquisiteAssignmentsMutation = gql`
  mutation PayrollDeleteUserPerquisiteAssignments($ids: [String!]!) {
    payrollDeleteUserPerquisiteAssignments(ids: $ids) {
      data
      code
      success
      message
    }
  }
`;

const deleteUserPerquisiteAssignments = (
  queryVariables: PayrollDeleteUserPerquisiteAssignmentsVariables,
) => {
  return graphQLApi<
    PayrollDeleteUserPerquisiteAssignmentsResponse,
    PayrollDeleteUserPerquisiteAssignmentsVariables
  >({
    query: deleteUserPerquisiteAssignmentsMutation,
    queryVariables,
  });
};

export default deleteUserPerquisiteAssignments;
